import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.flexara.ro';

const ResetParolaCerere: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [trimis, setTrimis] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');
    if (!email.trim()) { setError('Introdu adresa de email!'); return; }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/reset-password`, { email: email.trim() });
      setTrimis(true);
    } catch (e: any) {
      setError(e.response?.data?.detail || 'Eroare — încearcă din nou!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a1a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'DM Sans, sans-serif',
      padding: '1rem',
    }}>
      <div style={{
        background: '#1a1a30',
        borderRadius: '16px',
        padding: '2.5rem',
        width: '100%',
        maxWidth: '420px',
        border: '1px solid #2a2a4a',
      }}>
        <h1 style={{ color: '#fff', marginBottom: '0.5rem' }}>🔑 Flexara</h1>
        <p style={{ color: '#8080a0', marginBottom: '2rem' }}>Resetare parolă</p>

        {trimis ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#60d090', marginBottom: '1.5rem', fontSize: '1rem', lineHeight: 1.6 }}>
              Dacă emailul există în sistem, vei primi un link de resetare în câteva minute.
            </p>
            <button onClick={() => navigate('/login')} style={{
              width: '100%', padding: '0.75rem', borderRadius: '10px', border: 'none',
              background: '#4a4ad8', color: '#fff', fontSize: '1rem',
              fontWeight: 600, cursor: 'pointer',
            }}>
              Înapoi la autentificare
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <p style={{ color: '#8080a0', fontSize: '0.9rem', margin: 0 }}>
              Introdu adresa de email a contului tău și îți trimitem un link de resetare.
            </p>
            {error && (
              <p style={{ color: '#ff6060', fontSize: '0.9rem', margin: 0 }}>{error}</p>
            )}
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              style={{
                padding: '0.75rem',
                borderRadius: '10px',
                border: '1.5px solid #2a2a4a',
                background: '#0a0a1a',
                color: '#e0e0f0',
                fontSize: '1rem',
                width: '100%',
                boxSizing: 'border-box',
              }}
            />
            <button
              onClick={handleSubmit}
              disabled={loading}
              style={{
                padding: '0.75rem', borderRadius: '10px', border: 'none',
                background: '#4a4ad8', color: '#fff', fontSize: '1rem',
                fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? 'Se trimite...' : 'Trimite link de resetare'}
            </button>
            <button onClick={() => navigate('/login')} style={{
              padding: '0.6rem', borderRadius: '10px',
              border: '1px solid #2a2a4a', background: 'transparent',
              color: '#6060a0', cursor: 'pointer', fontSize: '0.9rem',
            }}>
              Înapoi la autentificare
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetParolaCerere;
